// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.61 7.84 C6.28 7.06 7.06 6.28 7.84 6.61 L13.83 9.1 C14.47 9.37 14.47 10.29 13.82 10.55 L12.1 11.23 C11.71 11.39 11.39 11.71 11.23 12.1 L10.55 13.82 C10.29 14.47 9.37 14.47 9.1 13.83 Z',
  'M4.4 1.5 L5.05 3.85 M1.5 4.4 L3.85 5.05 M8.8 2.3 L7.2 3.9 M2.3 8.8 L3.9 7.2',
];
